'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldHide = exports.shouldShow = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _minimatch = require('minimatch');

var _minimatch2 = _interopRequireDefault(_minimatch);

var _createConditional = require('./createConditional');

var _createConditional2 = _interopRequireDefault(_createConditional);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var displayName = 'State';

var propTypes = {
  value: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string])
};

var matches = function matches(value, machineState) {
  var values = Array.isArray(value) ? value : [value];
  var states = Array.isArray(machineState) ? machineState : [machineState];

  return values.some(function (val) {
    return states.some(function (state) {
      return (0, _minimatch2.default)(state, val);
    });
  });
};

var shouldShow = exports.shouldShow = function shouldShow(props, context) {
  return matches(props.value, context.machineState);
};

var shouldHide = exports.shouldHide = function shouldHide(props, context) {
  return !matches(props.value, context.machineState);
};

exports.default = (0, _createConditional2.default)({
  displayName: displayName,
  propTypes: propTypes,
  shouldShow: shouldShow,
  shouldHide: shouldHide
});


//////////////////
// WEBPACK FOOTER
// ./~/react-automata/lib/State.js
// module id = 1170
// module chunks = 168707334958949